import { useUserFormFieldsQuery } from "@/hooks/services";
import type { FormInstance } from "antd";
import dayjs from "dayjs";
import { useEffect } from "react";
import type { FormInstance as AdviceFormInstance } from "antd/es/form";
import { PerformanceEvaluationDetail } from "@/types/apis";

type Props = {
  queryResult: PerformanceEvaluationDetail | undefined;
  form: FormInstance;
  adviceForm: AdviceFormInstance;
  open: boolean;
};

export function useSupplierBasicFormInit({
  queryResult,
  form,
  adviceForm,
  open,
}: Props) {
  const userInfo = useUserFormFieldsQuery(queryResult?.createBy);

  // 初始化供应商基本信息表单
  useEffect(() => {
    if (!queryResult) return;

    form.setFieldsValue({
      supplierName: queryResult.supplierName,
      supplierCode: queryResult.supplierCode,
      supplierUserId: queryResult.supplierUserId,
      supplierCategoryId: queryResult.supplierCategoryId,
      purchaseAmount: queryResult.purchaseAmount,
      riskLevel: queryResult.riskLevel,
      assessmentScore: queryResult.assessmentScore,
    });

    if (queryResult.evaluationStatus === 2 && queryResult.evaluationAdvice) {
      adviceForm.setFieldsValue({
        evaluationAdvice: queryResult.evaluationAdvice,
      });
    }
  }, [queryResult, form, adviceForm]);

  // 初始化用户信息表单
  useEffect(() => {
    if (!userInfo || !open) return;

    form.setFieldsValue({
      username: userInfo.nickname,
      employeeCode: userInfo.username,
      createDate: queryResult?.createTime
        ? dayjs(queryResult.createTime).format("YYYY-MM-DD")
        : dayjs().format("YYYY-MM-DD"),
      department: userInfo.deptName,
      postName: userInfo.postName,
      email: userInfo.email,
    });
  }, [userInfo, form, queryResult, open]);
}
